/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FilePermission { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    /**
     * Nivel de permiso para el archivo
     */
    permissionLevel: FilePermission.PermissionLevelEnum;
    fileId: string;
    userId?: number;
    companyId?: string;
}
export namespace FilePermission {
    export type PermissionLevelEnum = 'viewer' | 'editor';
    export const PermissionLevelEnum = {
        Viewer: 'viewer' as PermissionLevelEnum,
        Editor: 'editor' as PermissionLevelEnum
    };
}


